import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyB_CEpFktgKvTFfqM4YTn3aLuK13-H0toY",
    authDomain: "folarin-odeyemi-cd38e.firebaseapp.com",
    projectId: "folarin-odeyemi-cd38e",
    storageBucket: "folarin-odeyemi-cd38e.appspot.com",
    messagingSenderId: "941049351169",
    appId: "1:941049351169:web:78dca9900802a29175c400",
    measurementId: "G-QERKB62DR4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
